import API from "../utils/api";

export const createDiscount = async (discountData = {}) => {
   return API.post(`/admin/discount/create`, discountData);
}

export const fetchDiscountList = async (queryParams = { limit: 10, skip: 0 }) => {
   let query = `limit=${queryParams.limit}&skip=${queryParams.skip}`

   return API.get(`/admin/discount/get?${query}`);
}

export const deleteDiscount = async (discountId = "") => {
   return API.delete(`/admin/discount/delete/${discountId}`);
}

export const updateDiscount = async (discountId = "", discountData) => {
   return API.post(`/admin/discount/update/${discountId}`, discountData);
}

// seller Discount APIs 
export const fetchDeliveryOptionsList = async () => {
   return API.get(`/common/delivery-option/get`);
}

export const createSellerDiscount = async (SellerDiscountData) => {
   return API.post(`/admin/discount/add-to-seller`, SellerDiscountData);
}
export const deleteSellerDiscount = async (SellerDiscountId) => {
   return API.delete(`/admin/discount/remove-to-seller/${SellerDiscountId}`);
}